module.exports = __webpack_public_path__ + "static/media/titikiImagesec.df18384e.gif";